import { render, staticRenderFns } from "./AnimationIssuesDecisionsHistoricDialog.vue?vue&type=template&id=8e0f281c&"
import script from "./AnimationIssuesDecisionsHistoricDialog.vue?vue&type=script&lang=js&"
export * from "./AnimationIssuesDecisionsHistoricDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports